import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, starfishMediaType, SFNotification } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';
import EditAppointmentView from './EditAppointmentView';

export default class EditAppointmentContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      hasFetched: false,
      appointment: null
    };
  }

  componentDidMount() {
    this.props.notification.dismiss(); // Clear notifications
    this.setState({hasFetched: false});
    const URL = `../api/starfish/appointments/appointments/${this.props.id}?rescheduling=true`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('appointments')
      }
    })
    .then(({appointment}) => {
      if ( appointment === null ) {
        window.location.href = "#"; // Go to home
        this.props.notification.error("This appointment is not available at this time");
      } else this.setState({appointment});
    })
    .catch(e => this.props.notification.error(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <EditAppointmentView
        {...this.state}
        notification={this.props.notification}
        timeZone={this.props.timeZone}
        partyId={this.props.partyId}
      />
    );
  }
}

EditAppointmentContainer.propTypes = {
  notification: SFNotification.isRequired,
  id: SFEntityID.isRequired,
  partyId: SFEntityID.isRequired,
  timeZone: PropTypes.string.isRequired
};
